import { useEffect, useRef } from 'react';
import API from '@Services/apiAxios';

export const useHealthCheck = (isOpen: boolean, sessionId: string) => {
  const lastCheckedSessionIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (isOpen && sessionId && sessionId !== lastCheckedSessionIdRef.current) {
      console.info(`Performing health check GET request to /speedboxbot/health for session: ${sessionId}`);
      lastCheckedSessionIdRef.current = sessionId;
      API.get('/speedboxbot/health')
        .then(response => {
          console.info('✅ Health check succeeded:', response.data);
        })
        .catch(error => {
          console.warn('⚠️ Health check failed:', error);
        });
    }
  }, [isOpen, sessionId]);
};
